<app-info-page
  title="Recomendaciones"
  [subtitle]="subtitle"
  [prefix]="address"
  [imageSrc]="imageSrc"
  [imageAlt]="imageAlt"
>
  <p class="info-card__text" [innerHTML]="text | nl2br"></p>
</app-info-page>
<div class="actions">
  <a *ngFor="let a of topActions" (click)="open(a.href)" class="action-link">
    <round-button [label]="a.label" class="action-btn"></round-button>
  </a>
</div>
